interface StatCardProps {
    number: string;
    description: string;
    className?: string;
    descriptionWidth?: string;
}

function StatCard({ number, description, className = "", descriptionWidth = "w-1/2" }: StatCardProps) {
    return (
        <div className={`border-l border-gray-400 p-4 flex flex-col justify-between ${className}`}>
            <div className="font-display lg:text-7xl md:text-6xl text-5xl font-black leading-[0.85] w-min">
                {number}
            </div>
            <p className={`text-gray-600 text-xs ${descriptionWidth}`}>{description}</p>
        </div>
    );
}

export function Statistics() {
    const stats = [
        {
            number: "5+",
            description: "Years of Experience",
            className: "h-50",
            descriptionWidth: "w-2/3"
        },
        {
            number: "500+",
            description: "Pull requests merged",
            className: "h-30",
            descriptionWidth: "w-1/2"
        },
        {
            number: "20+",
            description: "Projects Completed",
            className: "h-50",
            descriptionWidth: "w-1/2"
        },
        {
            number: "10+",
            description: "Third party integrations",
            className: "h-30 lg:!border-r",
            descriptionWidth: "w-1/2",
            wrapperClassName: "h-50"
        },
    ];

    return (
        <section className="py-16 w-full" id="stats">
            <div className="max-w-7xl mx-auto">
                <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 items-end gap-y-12 lg:gap-y-0">
                    {stats.map((stat, index) => (
                        stat.wrapperClassName ? (
                            <div key={index} className={stat.wrapperClassName}>
                                <StatCard
                                    number={stat.number}
                                    description={stat.description}
                                    className={stat.className}
                                    descriptionWidth={stat.descriptionWidth}
                                />
                            </div>
                        ) : (
                            <StatCard
                                key={index}
                                number={stat.number}
                                description={stat.description}
                                className={stat.className}
                                descriptionWidth={stat.descriptionWidth}
                            />
                        )
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Statistics;
